import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Admin 페이지 타이틀 매핑
const PAGE_TITLES: Record<string, string> = {
  '/': '대시보드',
  '/users': '회원 관리',
  '/organizations': '조직 관리',
  '/subscriptions': '구독 관리',
  '/products': '상품 관리',
  '/contents': '콘텐츠 관리',
  '/login': '로그인',
}

// 동적 라우트 패턴
const DYNAMIC_PATTERNS: Array<{ pattern: RegExp; title: string }> = [
  { pattern: /^\/users\/\d+$/, title: '회원 상세' },
  { pattern: /^\/organizations\/\d+$/, title: '조직 상세' },
]

const BASE_TITLE = 'Quebon Admin'

export function usePageTitle(customTitle?: string): void {
  const location = useLocation()

  useEffect(() => {
    let pageTitle: string | undefined = customTitle

    if (!pageTitle) {
      // 정확한 경로 매칭
      pageTitle = PAGE_TITLES[location.pathname]

      // 동적 패턴 매칭
      if (!pageTitle) {
        const matched = DYNAMIC_PATTERNS.find(({ pattern }) =>
          pattern.test(location.pathname)
        )
        if (matched) pageTitle = matched.title
      }
    }

    // Title is set once in main.tsx to window.location.host
  }, [location.pathname, customTitle])
}
